import { c as _c } from "react/compiler-runtime";
import _ from 'lodash';
import { twMerge } from 'tailwind-merge';
import { CruzIcon } from '../icon';
const variantStyles = {
  primary: 'btn-primary',
  secondary: 'btn-secondary',
  outline: 'btn-outline',
  outlineHc: 'btn-outline-hc',
  transparent: 'btn-transparent',
  bubble: 'btn-bubble'
};
type ButtonProps = {
  variant?: keyof typeof variantStyles;
  working?: boolean;
} & React.ComponentPropsWithoutRef<'button'>;
export function Button(t0) {
  const $ = _c(24);
  let children;
  let props;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[0] !== t0) {
    const {
      variant: t6,
      className,
      children: t7,
      "aria-label": ariaLabel,
      ...t8
    } = t0;
    children = t7;
    props = t8;
    const variant = t6 === undefined ? "primary" : t6;
    t1 = "button";
    const t9 = variantStyles[variant];
    if ($[8] !== className || $[9] !== t9) {
      t2 = twMerge("h-10 truncate overflow-hidden rounded px-3 text-sm/6 font-medium transition duration-300 dark:font-normal", t9, className);
      $[8] = className;
      $[9] = t9;
      $[10] = t2;
    } else {
      t2 = $[10];
    }
    t3 = ariaLabel || (typeof children === "string" ? children : undefined);
    t4 = props?.working || undefined;
    t5 = _.omit(props, "working");
    $[0] = t0;
    $[1] = children;
    $[2] = props;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
  } else {
    children = $[1];
    props = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
    t4 = $[6];
    t5 = $[7];
  }
  const t6 = props.disabled || props?.working;
  let t7;
  if ($[11] !== props.working) {
    t7 = props?.working && <CruzIcon.Spin aria-hidden="true" className="mr-1 text-white" />;
    $[11] = props.working;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== children || $[14] !== t7) {
    t8 = <div className="flex items-center justify-center gap-x-2">{t7}{children}</div>;
    $[13] = children;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t1 || $[17] !== t2 || $[18] !== t3 || $[19] !== t4 || $[20] !== t5 || $[21] !== t6 || $[22] !== t8) {
    t9 = <button type={t1} className={t2} aria-label={t3} aria-busy={t4} {...t5} disabled={t6}>{t8}</button>;
    $[16] = t1;
    $[17] = t2;
    $[18] = t3;
    $[19] = t4;
    $[20] = t5;
    $[21] = t6;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  return t9;
}